// extracted by mini-css-extract-plugin
export default {"vspacing":"gift-code-redemption-vspacing","container":"gift-code-redemption-container"};